/**
 * PostHog omits `{ errorsLoading }` when `onFeatureFlags` replays to a late
 * subscriber after flags already loaded (posthog-js 1.276.0). Cache the last
 * explicit context so hooks mounted after a failed `/flags` request still fail
 * open with `resolutionReason: 'error'`.
 */
let lastFeatureFlagsErrorsLoading: boolean | undefined;

export function recordFeatureFlagsLoadContext(
  context: { errorsLoading?: boolean } | undefined
): void {
  if (context !== undefined) {
    lastFeatureFlagsErrorsLoading = context.errorsLoading === true;
  }
}

export function resolveFeatureFlagsErrorsLoading(
  context: { errorsLoading?: boolean } | undefined
): boolean {
  recordFeatureFlagsLoadContext(context);
  if (context !== undefined) {
    return context.errorsLoading === true;
  }
  return lastFeatureFlagsErrorsLoading === true;
}

/** Test-only reset for isolated unit tests. */
export function resetFeatureFlagsLoadStateForTests(): void {
  lastFeatureFlagsErrorsLoading = undefined;
}
